export default "__VITE_ASSET__D27Uqbi0__"